import { initI18n } from "@cloudaccelerator-ui/react-library";

/**
 * Convert a flat-key translations object (e.g. { "homePage.welcome": "..." })
 * into the nested structure i18next expects (e.g. { homePage: { welcome: "..." } }).
 */
function unflattenKeys(flat: Record<string, string>): Record<string, unknown> {
  const result: Record<string, unknown> = {};

  for (const [key, value] of Object.entries(flat)) {
    const parts = key.split(".");
    let current: Record<string, unknown> = result;

    for (let i = 0; i < parts.length - 1; i++) {
      if (!(parts[i] in current)) {
        current[parts[i]] = {};
      }
      current = current[parts[i]] as Record<string, unknown>;
    }

    current[parts[parts.length - 1]] = value;
  }

  return result;
}

/**
 * Fetch a flat-key translation JSON file from public/locales/ and convert to nested format.
 */
async function loadTranslations(locale: string): Promise<Record<string, unknown>> {
  const response = await fetch(`/locales/${locale}.translations.json`);

  if (!response.ok) {
    throw new Error(`Failed to load translations for "${locale}": ${response.status}`);
  }

  const flat = (await response.json()) as Record<string, string>;
  return unflattenKeys(flat);
}

/**
 * Initialize i18next with the library's configuration.
 * Translation files are loaded from public/locales/{locale}.translations.json.
 */
export async function initializeI18n(): Promise<void> {
  const en = await loadTranslations("en-us");

  await initI18n({
    defaultLanguage: "en",
    debug: false,
    resources: {
      en: { translation: en },
    },
  });
}
